import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { ChangePassComponent } from './change-pass/change-pass.component';
import { UserlogPopupComponent } from '../../users/modal-popup/userlog-popup/userlog-popup.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  // directive: [ClickOutside]
})
export class HeaderComponent implements OnInit {
  @ViewChild(UserlogPopupComponent) logModal: UserlogPopupComponent;
  @ViewChild(ChangePassComponent) changePassModal: ChangePassComponent;
  toggleMenu = 'none';
  toggleReport = 'none';
  me_img = './assets/images/user.png';
  currentUserDetail;
  currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  ImagesOption = sessionStorage.getItem('ImagesOption');
  username: string;
  constructor(
    public router: Router,
    private authenticationService: AuthenticationService) {

  }
  ngOnInit() {
    // this.currentUserDetail = this.jwtHelper.decodeToken(this.currentUser.token);
    if (JSON.parse(sessionStorage.getItem('currentUser'))) {
      this.username = JSON.parse(sessionStorage.getItem('currentUser')).name;
      if (JSON.parse(sessionStorage.getItem('currentUser')).profile_pic) {
        this.me_img = JSON.parse(sessionStorage.getItem('currentUser')).profile_pic;
      }
    }
  }
  openProfile() {
    this.toggleMenu = 'block';
  }
  closeProfile() {
    this.toggleMenu = 'none';
  }
  onToggleReport() {
    if (this.toggleReport === 'block') {
      this.toggleReport = 'none';
    } else {
      this.toggleReport = 'block';
    }
  }
  onToggleProfile() {
    if (this.toggleMenu === 'block') {
      this.toggleMenu = 'none';
    } else {
      this.toggleMenu = 'block';
    }
  }
  onClickOutside() {
    this.toggleMenu = 'none';
  }
  logout() {
    this.authenticationService.logout();
    this.router.navigate(['login']);
  }
  changePassword() {
    this.changePassModal.showModal();
  }
  addLog() {
    this.logModal.showModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/header/header.component.ts